import { Component, Input, OnInit } from '@angular/core';
import { OrgaoConfiguracao } from '../../entidade/comum/orgao-configuracao.model';
import { FuncaoService } from '../../util/funcao.service';
import { GlobalService } from '../../util/global.service';

@Component({
  selector: 'lib-orgao-configuracao-shw',
  templateUrl: './orgao-configuracao-shw.component.html'
})
export class OrgaoConfigracaoShwComponent implements OnInit {

  @Input() configuracao: OrgaoConfiguracao;

  public cloudArmazenamentos: {
    id: string,
    nome: string
  }[] = [];

  constructor(private funcaoService: FuncaoService,
    private globalService: GlobalService) { }

  ngOnInit(): void {
    this.cloudArmazenamentos = this.globalService.obterCloudArmazenamento();
  }

  compareFn(c1: any, c2: any): boolean {
    if (c1 && c2) {
      if (c1.id && c2.id) {
        return c1.id === c2.id;
      } else if (c1.chave && c2.chave) {
        return c1.chave == c2.chave;
      } else {
        return c1 === c2;
      }
    } else {
      return false;
    }
  }

}
